// extracted by mini-css-extract-plugin
export var closeButton = "_n6-1";
export var closeX = "_n6-3";
export var container = "_n6-0";
export var image = "_n6-2";